export const TRACTAFRIC_COUNTRIES_HIDE_MAP = [
  'MA',
  'CM',
  'TD',
  'GA',
  'CG',
  'CF',
  'GQ',
  'RW',
  'BI'
];

export const TRACTAFRIC_DEALER_CODE = 'K600';

export const MAP_RESTRICTED_COUNTRIES = new Set([
  ...TRACTAFRIC_COUNTRIES_HIDE_MAP
]);
export const MAP_RESTRICTED_DEALERS = new Set([TRACTAFRIC_DEALER_CODE]);
